import { SVGAttributes, VFC } from "react";

// eslint-disable-next-line react/require-default-props
const Phone: VFC<SVGAttributes<SVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.25 12A8.25 8.25 0 0 0 12 3.75v-1.5c5.385 0 9.75 4.365 9.75 9.75h-1.5ZM4.633 4.896a1.943 1.943 0 0 1 2.82-.077L9.11 6.477a1.939 1.939 0 0 1 0 2.743l-.842.841a.439.439 0 0 0 0 .622l5.048 5.047a.44.44 0 0 0 .623 0l.84-.84a1.94 1.94 0 0 1 2.744 0l1.657 1.657a1.944 1.944 0 0 1-.077 2.821c-1.595 1.42-3.372 2.489-5.538 2.373-2.145-.113-4.468-1.379-7.198-4.108-2.73-2.73-3.995-5.053-4.11-7.199-.115-2.166.954-3.943 2.375-5.538Zm1.759.983a.443.443 0 0 0-.638.014h-.001C4.43 7.38 3.673 8.778 3.756 10.356c.086 1.598 1.044 3.589 3.673 6.217 2.628 2.628 4.618 3.587 6.217 3.672 1.578.084 2.975-.674 4.46-1.996a.444.444 0 0 0 .015-.64l-1.657-1.657a.44.44 0 0 0-.623 0l-.84.84a1.94 1.94 0 0 1-2.745 0L7.21 11.743a1.939 1.939 0 0 1 0-2.742l.841-.842a.439.439 0 0 0 0-.621L6.392 5.879ZM12 7.75A4.25 4.25 0 0 1 16.25 12h1.5A5.75 5.75 0 0 0 12 6.25v1.5Z"
        fill="#191817"
      />
    </svg>
  );
};

export { Phone };
